import { useReducer, useRef } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { selectEndorsements, selectLimitDamagePremRented } from '../../../selectors/application';
import { endorsementsMap } from '../../AddOns/addOnQuestionMap';
import AddOnsSummaryCard from './AddOnSummaryCard';
import { SectionContainer, SectionSubHeader, SectionSubHeaderCont } from '../styles';
import EditSummaryButton from '../EditSummaryButton';
import { PAGES } from '../../../constants';
import isEmpty from 'lodash/isEmpty';

interface AdditionalCoveragesProps {
  endorsements: EndorsementsInterface;
  limitDamagePremRented?: number;
}

function AdditionalCoverages({ endorsements, limitDamagePremRented }: AdditionalCoveragesProps) {
  const [cachedEndorsements] = useReducer((state: any, action: any) => (action != null ? action : state), endorsements);
  const cachedEndorsementKeys = Object.keys(cachedEndorsements);
  const limitDamagePremRentedRef = useRef(limitDamagePremRented);

  const shouldRenderAddOns =
    !isEmpty(cachedEndorsements) &&
    cachedEndorsementKeys.reduce((accum: boolean, addedEndorsement: string) => {
      if (accum) return true;

      return Boolean(endorsementsMap[addedEndorsement] && cachedEndorsements[addedEndorsement]);
    }, false);

  if (!shouldRenderAddOns && !limitDamagePremRented) return null;

  return (
    <SectionContainer data-testid="additional-coverages">
      <SectionSubHeaderCont>
        <SectionSubHeader>Additional Coverages</SectionSubHeader>
        <EditButton page={PAGES.ADD_ONS} label="additional-coverages">
          Edit
        </EditButton>
      </SectionSubHeaderCont>

      {cachedEndorsementKeys.map((endorsement: string) =>
        endorsementsMap[endorsement] && cachedEndorsements[endorsement] ? (
          <AddOnsSummaryCard key={endorsement} endorsement={endorsement} value={cachedEndorsements[endorsement]} />
        ) : null
      )}
      {limitDamagePremRentedRef.current ? (
        <AddOnsSummaryCard endorsement="limitDamagePremRented" value={limitDamagePremRentedRef.current} />
      ) : null}
    </SectionContainer>
  );
}

const mapStateToProps = (state: ReduxState) => ({
  endorsements: selectEndorsements(state) || { additionalInsureds: [] },
  limitDamagePremRented: selectLimitDamagePremRented(state),
});

const EditButton = styled(EditSummaryButton)`
  font-size: 13px;
  margin-top: 16px;
  gap: 6px;
`;

export default connect(mapStateToProps)(AdditionalCoverages);
